export enum EAjaxFunctions {
	APP_RATE = 'perl_application_review_submit',
	APPS_UNINSTALL = 'app.uninstall',
	APPS_SHOW_BY_ID = 'app.show',
	APPS_INSTALLED = 'app.installed',
	APPS_NEW = 'app.new_apps',
	APPS_GENRE = 'app.genre_gender_age',
	APPS_POPULAR = 'app.lvisit_suggest',
	APPS_SALES = 'app.sale_apps',
	APPS_SHOWCASE = 'app.banana',
	APPS_EVENTS = 'app.event_apps',
	MOB_COUNTERS = 'counters.mobweb',

}
